import { render, staticRenderFns } from "./AltegioResolver.vue?vue&type=template&id=ecf56f72&scoped=true"
import script from "./AltegioResolver.vue?vue&type=script&lang=ts"
export * from "./AltegioResolver.vue?vue&type=script&lang=ts"
import style0 from "./AltegioResolver.vue?vue&type=style&index=0&id=ecf56f72&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf56f72",
  null
  
)

export default component.exports